import React from 'react';
import stylesNavigation from './Navigation.module.scss';
import { useSelector, useDispatch } from 'react-redux';
import * as actionTypes from '../../redux/actions/actionTypes';
import { Form, Button } from 'antd';
import Immagine from '../../components/Immagine/Immagine';

const Navigation = (props) => {

    const steps = useSelector(state => state.dataReducer.modello.currentStep);
    const erroriSalvaStep = useSelector(state => state.dataReducer.salvaStep.dati);
    const dispatch = useDispatch();

    function moveBack(){
        console.log('moving back', props.skip)
        props.skip && dispatch({type: actionTypes.STEP_INDIETRO_SKIP})
        !props.skip && dispatch({type: actionTypes.STEP_INDIETRO})
    }

    // Disabilita il pulsante Indietro se ci sono errori backend o frontend
    const hasBackendErrors = erroriSalvaStep && erroriSalvaStep.length > 0;
    const hasFrontendErrors = props.bloccoAvanzamento === true;
    const hasErrors = hasBackendErrors || hasFrontendErrors;

    return(
        <div className={stylesNavigation.Navigation}>
            {
            (steps > 0 && steps < 13) ?
                <Button onClick={moveBack} className={stylesNavigation.buttonIndietro} disabled={hasErrors}>Indietro</Button>
                : ''
            }

            <Form.Item>
                <Button type="primary" htmlType="submit" disabled={props.bloccoAvanzamento} loading={props.loadingStep}>
                Continua
                <Immagine urlImage={'right.svg'} name='go' />
                </Button>
            </Form.Item>
        </div>
    )
}

export default Navigation;